import React, { useState, useEffect } from "react";
import bcrypt from 'bcryptjs-react';
import './EmbedPoll.css';
import {setCookie, getCookie } from '../../common/utils';

const EmbedPoll = ({ pollObject,baseDomain,constants }) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [pollData, setPollData] = useState({
        options: [],
        submitted: false,
    });
    const [loading, setLoading] = useState(true); 
    const [alreadyVoted, setAlreadyVoted] = useState(false);
    useEffect(() => {
        if (pollObject) {
            setPollData({ options: pollObject.polloptions, submitted: false });
            setLoading(false); // Data is now available

            const pollTakenID = getCookie('pollTakenID');
            if (pollTakenID && pollTakenID === pollObject.msid) {
                setAlreadyVoted(true);
            }
        }
    }, [pollObject]);

    const handleOptionChange = (event) => {
        const value = event.target.value;
        setSelectedOption(value);
    };

    const generateClientId = () => `${Date.now()}-${Math.floor(Math.random() * 1000)}`;

    const handleSubmit = async (option) => {
        if (!option) return;
        const url = `${constants.CDS_API}/cds-feed-ext/submit/poll/m360`;
        

        const rawPayload = JSON.stringify({
            hostid: parseInt(pollObject?.hostid),
            clientId: generateClientId(),
            date: Date.now().toString(),
            location: "DemoLocation",
            msid: parseInt(pollObject?.msid),
            username: "DemoUser",
            voteoptionno: option,
        });
        const headerString = rawPayload;
        const hashedHeaderString = bcrypt.hashSync(headerString, 6);
        const headers = {
            'Content-Type': 'application/json',
            'p-nonce': hashedHeaderString 
        };
        try {
            const response = await fetch(url, { method: "POST", headers, body: rawPayload });
            if (response.ok) { // Check if the response is successful
                const result = await response.json(); // Assuming the response is JSON
                const pollmsid = result?.response?.params?.msid;
                setCookie('pollTakenID', pollmsid, 1); // Set cookie for 1 day
                updatePollOptions(option);
            } else {
                console.error('Error submitting poll:', response.statusText);
            }
        } catch (error) {
            console.error('Error submitting poll:', error);
        }
    };

    const updatePollOptions = (option) => {
        const updatedOptions = pollData.options.map(opt =>
            opt.optionno === option ? { ...opt, votecount: opt.votecount + 1 } : opt
        );

        const totalVotes = updatedOptions.reduce((total, opt) => total + opt.votecount, 0);
        const recalculatedOptions = updatedOptions.map(opt => ({
            ...opt,
            votepercent: totalVotes > 0 ? ((opt.votecount / totalVotes) * 100).toFixed(2) : 0,
        }));

        setPollData({ options: recalculatedOptions, submitted: true });
    };

    const getColor = (percent) => {
        if (percent > 70) return "#c0dbff";
        if (percent > 40) return "#F3D3D4";
        return "#D3EDDF";
    };

    useEffect(() => {
        if (selectedOption) {
            handleSubmit(selectedOption);
        }
    }, [selectedOption]);

    return (
        <div className="ComonEmbedPoll">
            <p className="ComonEmbedPollHeading"><span className="ComonEmbedPollDefaultText">POLL:</span> {pollObject?.title}</p>
            {loading ? ( 
                <p>Loading poll options...</p>
            ) : alreadyVoted ? (
                <p className="alreadyvoted">You have already voted</p>
            ) : (
                <ul>
                    {pollData.options.map((val, idx) => (
                        <div key={idx} className="CommonInsidePolInput">
                            <li style={{
                                width: `${val.votepercent}%`,
                                backgroundColor: pollData.submitted ? getColor(val.votepercent) : 'transparent',
                            }}>
                                <input
                                    type="radio"
                                    name="poll"
                                    value={val.optionno}
                                    onChange={handleOptionChange}
                                    disabled={pollData.submitted}
                                />
                            </li>
                           {/* <div className="ComonEmbedPollMainWrapper"></div> */}
                           <div className="ComonEmbedPollDiscriptionWrapper">{val.description}</div>
                           <div className="ComonEmbedPollSubmitWrapper"> {pollData.submitted ? `${val.votepercent}%` : ''}</div>
                           
                        </div>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default EmbedPoll;
